export default "__VITE_ASSET__BBFWubk4__"